<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data">
      <template #suffix>
        <b-button class="mr-2" variant="success" @click="exportMonthlyFullPaymentCountReport()">匯出每月繳滿人數</b-button>
      </template>
    </bread-crumb>

    <b-form-checkbox
      class="mb-2"
      switch
      size="lg"
      value=1
      unchecked-value=0
      v-model.number="search.plan"
      @change="getReportMonthPayOff(1)"
    >
      是否分組
    </b-form-checkbox>

    <tables-page
      :tableData="data.table_data"
      :tableFields="tableFields"
      :pageData="data.page"
      v-on:result="getReportMonthPayOff"
    >
      <template #cell(year_month)="row">
        <span v-if="search.plan">
          {{ Number(row.item.month.split('-')[0]) - 1911 }}-{{ row.item.month.split('-')[1] }}
        </span>

        <span
          v-else
          class="link"
          @click="openContractModal(row.item)"
        >
         {{ Number(row.item.month.split('-')[0]) - 1911 }}-{{ row.item.month.split('-')[1] }}
        </span>
      </template>

      <template #cell(bar_chart)="row">
        <b-progress :value="row.item.count" :max="data.bar_max_value" show-value></b-progress>
      </template>

    </tables-page>

    <!-- 契約 modal -->
    <monthly-full-payment-count-contract-modal
      v-model="status.contractModal"
      :data="data.temp_table_data" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import reportApi from "@/models/API/reportApi";
import TablesPage from "@/components/layouts/TablesPage";
import MonthlyFullPaymentCountContractModal from"./components/modal/MonthlyFullPaymentCountContractModal";
import { downloadFile } from "@/models/HELPERS/common.js";

export default {
  name: 'monthlyFullPaymentCount',
  components: {
    BreadCrumb,
    TablesPage,
    MonthlyFullPaymentCountContractModal
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '報表', url: '', isActive: true },
          { name: '每月繳滿人數', url: '', isActive: false }
        ]
      },
      status: {
        contractModal: false
      },
      search: {
        plan: 0
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "year_month",
            label: "年月",
          },
          {
            key: "count",
            label: "人數",
          },
          {
            key: "bar_chart",
            label: "長條圖",
          }
        ],
        page: {},
        temp_table_data: {},
        bar_max_value: 100,
      },
    }
  },
  computed: {
    tableFields() {
      let fields = [
        {
          key: "year_month",
          label: "年月",
        },
        {
          key: "count",
          label: "人數",
        },
        {
          key: "bar_chart",
          label: "長條圖",
        }
      ];

      if (this.search.plan) {
        fields.unshift({
          key: "plan",
          label: "組別",
        })
      }

      return fields;
    }
  },
  mounted() {
    this.reportApi = new reportApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.reportApi.page);
      this.getReportMonthPayOff();
    },
    // 取得每月繳滿人數
    getReportMonthPayOff(pageIndex = null) {
      const params = {
        ...this.search,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };

      this.reportApi.getReportMonthPayOff((response) => {
        const res = response.data;

        this.data.bar_max_value = Math.max(...res.data.map(item => item.count));
        this.data.page.totalCount = res.total; // 總筆數
        this.data.table_data = res.data;
      }, params)
    },
    // 開啟契約 modal
    openContractModal(item = null) {
      this.status.contractModal = true;
      this.data.temp_table_data = Object.assign({}, item);
    },
    // 匯出每月繳滿人數
    exportMonthlyFullPaymentCountReport() {
      const params = {
        ...this.search,
        type: 3
      };

      this.reportApi.exportReportMonth((response) => {
        if (!response) return;

        downloadFile(response);
      }, params)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/monthlyFullPaymentCount.vue